// extracted by mini-css-extract-plugin
module.exports = {"popupRow":"List_popupRow_2gmiG","pagination":"List_pagination_3NCPl","paginationText":"List_paginationText_NeqIU","paginationButton":"List_paginationButton_1d6MT"};